import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { ProductTypeMap } from './ProductTypeMap';

export default class ProductTypesResource extends FBaseService {
  public async get(): Promise<ProductTypeMap> {
    const url = '/api/rcx/config/product-types';

    const response: AxiosResponse = await this.apiClient.get(url);
    return response.data.data;
  }
}
